export default __webpack_public_path__ + "static/media/Newsletter 006.7a3bc627.png";